export interface ReaderEnvironmentConfig {
  sdlc: string
  services: Services
  branchkeys: Branchkeys
}

export interface Services {
  ePubFactory: string
  PlayerAPI: string
  MHEReaderAPI: string
  MHEDarkReaderAPI: string
  TTSApi: string
  ContentAgnosticTool: string
  ePubFactoryCDN: string
}
export interface Branchkeys {
  con: string
  atd: string
}

export const defaultReaderEnvironmentConfig: ReaderEnvironmentConfig = {
  sdlc: '',
  services: {
    PlayerAPI: '',
    MHEReaderAPI: '',
    MHEDarkReaderAPI: '',
    TTSApi: '',
    ContentAgnosticTool: '',
    ePubFactory: '',
    ePubFactoryCDN: '',
  },
  branchkeys: {
    con: '',
    atd: '',
  },
};
